module.exports = __webpack_public_path__ + "img/qgisat_new.bc02773f.png";